import type { StageDefinition } from '../types'

// Stage definitions with grid positions for n8n-style layout
// Layout: 4 columns per row, flowing left-to-right, top-to-bottom
export const STAGE_DEFINITIONS: StageDefinition[] = [
  // Row 1: Initial stages
  { id: 'preflight_validation', displayName: 'Preflight Check', description: 'Validating URL and capabilities', phase: 'understand', row: 0, col: 0 },
  { id: 'brand_discovery', displayName: 'Brand Discovery', description: 'Learning about your brand', phase: 'understand', row: 0, col: 1 },
  { id: 'meta_identity_resolution', displayName: 'Meta Identity', description: 'Finding your Meta page', phase: 'understand', row: 0, col: 2 },
  { id: 'brand_ad_collection', displayName: 'Ad Collection', description: 'Collecting your ads', phase: 'understand', row: 0, col: 3 },

  // Row 2: Analysis stages
  { id: 'individual_ad_analysis', displayName: 'Ad Analysis', description: 'Analyzing each ad', phase: 'understand', row: 1, col: 0 },
  { id: 'competitor_intelligence', displayName: 'Competitors', description: 'Analyzing competitors', phase: 'understand', row: 1, col: 1 },
  { id: 'product_bible', displayName: 'Product Bible', description: 'Creating product guide', phase: 'strategize', row: 1, col: 2 },
  { id: 'strategy_selection', displayName: 'Strategy', description: 'Selecting best strategy', phase: 'strategize', row: 1, col: 3 },

  // Row 3: Creation stages
  { id: 'creative_blueprint', displayName: 'Blueprint', description: 'Designing creative', phase: 'strategize', row: 2, col: 0 },
  { id: 'clip_bank_creation', displayName: 'Clip Bank', description: 'Creating clip library', phase: 'strategize', row: 2, col: 1 },
  { id: 'ai_asset_synthesis', displayName: 'AI Assets', description: 'Generating AI assets', phase: 'create', row: 2, col: 2 },
  { id: 'variant_generation', displayName: 'Variants', description: 'Generating ad variants', phase: 'create', row: 2, col: 3 },

  // Row 4: Final stages
  { id: 'scoring_and_selection', displayName: 'Scoring', description: 'Scoring variants', phase: 'create', row: 3, col: 0 },
  { id: 'final_production', displayName: 'Production', description: 'Rendering final video', phase: 'deliver', row: 3, col: 1 },
]

// Define edges between stages (source -> target)
export const STAGE_CONNECTIONS: Array<[string, string]> = [
  ['preflight_validation', 'brand_discovery'],
  ['brand_discovery', 'meta_identity_resolution'],
  ['meta_identity_resolution', 'brand_ad_collection'],
  ['brand_ad_collection', 'individual_ad_analysis'],
  ['individual_ad_analysis', 'competitor_intelligence'],
  ['competitor_intelligence', 'product_bible'],
  ['product_bible', 'strategy_selection'],
  ['strategy_selection', 'creative_blueprint'],
  ['creative_blueprint', 'clip_bank_creation'],
  ['clip_bank_creation', 'ai_asset_synthesis'],
  ['ai_asset_synthesis', 'variant_generation'],
  ['variant_generation', 'scoring_and_selection'],
  ['scoring_and_selection', 'final_production'],
]

export const getStageDefinition = (stageId: string): StageDefinition | undefined => {
  return STAGE_DEFINITIONS.find(s => s.id === stageId)
}

export const PHASE_COLORS = {
  understand: { bg: 'bg-blue-500/10', border: 'border-blue-500/30', text: 'text-blue-400' },
  strategize: { bg: 'bg-purple-500/10', border: 'border-purple-500/30', text: 'text-purple-400' },
  create: { bg: 'bg-amber-500/10', border: 'border-amber-500/30', text: 'text-amber-400' },
  deliver: { bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', text: 'text-emerald-400' },
}
